"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectPreRenderedStyles = void 0;
const links_1 = require("../links");
const collectPreRenderedStyles = () => {
    const styles = Object.values(document.head.querySelectorAll(`style[${links_1.TAG_CSS_CHUNK_ID}]`));
    styles.forEach((style) => {
        links_1.browserCssMetaList.push({
            id: style.getAttribute(links_1.TAG_CSS_CHUNK_ID),
            content: style.textContent || '',
        });
    });
    Object.assign(window, { browserCssMetaList: links_1.browserCssMetaList });
};
exports.collectPreRenderedStyles = collectPreRenderedStyles;
